import { isAndroid } from 'react-device-detect';

export const SHOULD_INSERT_CUSTOM_MEDIA_PICKER_MENU = isAndroid;
